import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Badge } from '@/components/ui/badge';
import { Loader2, Eye } from 'lucide-react';

/**
 * Anteprima dell'email brandizzata prima dell'invio.
 * props: open, onOpenChange, preview: {subject, html, from_email, from_name, reply_to, sender_note}, loading
 */
export function EmailPreviewDialog({ open, onOpenChange, preview, loading }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="email-preview-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Eye className="size-4 text-primary" />Anteprima email</DialogTitle>
          <DialogDescription>Così apparirà l’email al cliente. Puoi personalizzare mittente, oggetto e testo nel profilo azienda.</DialogDescription>
        </DialogHeader>
        {loading ? (
          <div className="p-8 flex items-center justify-center text-muted-foreground text-sm gap-2">
            <Loader2 className="size-4 animate-spin" /> Caricamento anteprima...
          </div>
        ) : preview ? (
          <div className="space-y-3">
            <div className="rounded-lg border divide-y text-sm">
              <div className="flex gap-2 px-3 py-2">
                <span className="text-muted-foreground w-24 shrink-0">Da</span>
                <span className="font-medium truncate" data-testid="email-preview-from">
                  {preview.from_name ? `${preview.from_name} <${preview.from_email || '—'}>` : (preview.from_email || '—')}
                </span>
              </div>
              {preview.reply_to && (
                <div className="flex gap-2 px-3 py-2">
                  <span className="text-muted-foreground w-24 shrink-0">Risposte a</span>
                  <span className="truncate">{preview.reply_to}</span>
                </div>
              )}
              <div className="flex gap-2 px-3 py-2">
                <span className="text-muted-foreground w-24 shrink-0">Oggetto</span>
                <span className="font-medium" data-testid="email-preview-subject">{preview.subject}</span>
              </div>
            </div>
            {preview.sender_note && (
              <div className="text-xs text-muted-foreground bg-secondary/50 border rounded-md px-3 py-2">{preview.sender_note}</div>
            )}
            <div className="rounded-lg border overflow-hidden bg-muted/30">
              <iframe
                title="Anteprima email"
                srcDoc={preview.html}
                sandbox=""
                className="w-full h-[420px] bg-white"
                data-testid="email-preview-iframe"
              />
            </div>
          </div>
        ) : (
          <div className="p-8 text-center text-sm text-muted-foreground">Anteprima non disponibile</div>
        )}
      </DialogContent>
    </Dialog>
  );
}
